import { Container, Grid } from '@material-ui/core';
import React from 'react';
import { useParams } from 'react-router-dom';
import ClientPriceItemEditForm from './components/ClientPriceItemEditForm';
import ClientEditSidebar, {
    ACTIVE_CLIENT_SIDEBAR_TAB_NAMES
} from '../clientedit/ClientEditSidebar';

const ClientPriceItemEditPage = () => {
    const { clientId } = useParams();
    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <ClientEditSidebar activeTab={ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.clientpriceitems} />
                <Grid className="pageContent">
                    <ClientPriceItemEditForm clientId={clientId} />
                </Grid>
            </Grid>
        </Container>
    );
};

export default ClientPriceItemEditPage;
